import { sessionApiClient } from "@planningcenter/cc-api-client"
import { GivingPersonNotificationsAttributes } from "./types"

export async function fetchGivingPerson(): Promise<GivingPersonNotificationsAttributes> {
  const response = await sessionApiClient.get("/giving/v2/me")
  return response.data.attributes
}
